import { getSharedStrings } from '../xml/xlsx';
export default function parseSharedStrings(content, xml) {
  if (!content) {
    return [];
  }

  return getSharedStrings(xml.createDocument(content));
}
//# sourceMappingURL=parseSharedStrings.js.map


//////////////////
// WEBPACK FOOTER
// ./~/read-excel-file/modules/read/parseSharedStrings.js
// module id = 1537
// module chunks = 1